<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <Alert banner closable>协作单位必须是已在库单位</Alert>
              <FormItem
                label="协作单位"
                prop="company"
              >
                <el-select
                 :disabled="formValidate.id !== 0"
                  v-model="formValidate.company"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入协作单位"
                  :remote-method="remoteMethod"
                  :loading="loading">
                  <el-option
                    v-for="item in companyoptions"
                    :key="item.Cname"
                    :label="item.Cname"
                    :value="item.Cname">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="联系电话"
                prop="phone"
              >
                <Input
                  v-model="formValidate.phone"
                  placeholder="请输入联系电话"
                ></Input>
              </FormItem>
              <FormItem
                label="联系人"
                prop="linkman"
              >
                <Input
                  v-model="formValidate.linkman"
                  placeholder="请输入联系人"
                ></Input>
              </FormItem>
              <FormItem
                label="地址"
                prop="address"
              >
                <Input
                  v-model="formValidate.address"
                  placeholder="请输入地址"
                ></Input>
              </FormItem>
              <FormItem
                label="状态"
                prop="status"
              >
                <el-select
                  v-model="formValidate.status"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择状态">
                  <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getLaborcompanylist,
  operationLaborcompany
} from '@/api/labor/laborcompany.js'
import {getsysparameterList} from '@/api/system/sys_parameter'
import {
  getCompanylist
} from '@/api/scinfo/scinfo.js'

let moment = require('moment')
export default {
  data () {
    return {
      spinShow: false,
      companylist: [],
      companyoptions: [],
      loading: false,
      fullscreenLoading: false,
      statusList: [],
      auditsList: [],
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
//        company: [
//          {
//            required: true,
//            message: '协作单位不能为空',
//            trigger: 'blur'
//          }
//        ],
        phone: [
          {
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          }
        ],
        linkman: [
          {
            required: true,
            message: '联系人不能为空',
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: '地址不能为空',
            trigger: 'blur'
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '协作单位',
          key: 'company',
          width: 220,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '联系电话',
          key: 'phone',
          width: 180,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '联系人',
          key: 'linkman',
          width: 120,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '地址',
          key: 'address',
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '状态',
          key: 'status_CN',
          width: 120,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '合同开始时间',
          key: 'stime',
          tooltip: true,
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '合同结束时间',
          key: 'etime',
          tooltip: true,
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'post', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  methods: {
//    getCompanylist (key, value) {
//      getCompanylist(this.pageNum, this.pageSize, key, value).then(res => {
//        if (res.data.code === 0) {
//          this.pageTotal = res.data.count
//          this.tableData = res.data.data
//        } else {
//          this.$Message.error(`${res.data.msg}`)
//        }
//      })
//    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          getCompanylist(1, 20, query, '').then(res => {
            if (res.data.code === 0) {
              this.companyoptions = res.data.data
            }
          })
//          this.companyoptions = this.companylist.filter(item => {
//            return item.label.toLowerCase()
//                    .indexOf(query.toLowerCase()) > -1
//          })
        }, 200)
      } else {
        this.companyoptions = []
      }
    },
    getLaborcompanylist (key, value) {
      this.spinShow = true
      getLaborcompanylist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList () {
      getsysparameterList('labor_company', 'status').then(res => {
        if (res.data.code === 0) {
          this.statusList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('labor_company', 'audits').then(res => {
        if (res.data.code === 0) {
          this.auditsList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal () {
      this.dialog.show = false
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getParameterList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          company: paramsRow.company,
          phone: paramsRow.phone,
          linkman: paramsRow.linkman,
          address: paramsRow.address,
          status: paramsRow.status,
          apply_time: paramsRow.apply_time,
          audits: paramsRow.audits
        }
      } else {
        this.formValidate = {
          id: 0,
          company: '',
          phone: '',
          linkman: '',
          address: '',
          status: 1,
          apply_time: s2,
          audits: ''
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.apply_time = moment(this.formValidate.apply_time).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationLaborcompany(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getLaborcompanylist(this.searchVal)
                } else {
                  this.getLaborcompanylist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          console.log(this.formValidate)
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handlerDelete () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationLaborcompany({'id_list': this.tableSelectIdList}, 'delete').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getLaborcompanylist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationLaborcompany(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getLaborcompanylist(this.searchVal)
      } else {
        this.getLaborcompanylist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getLaborcompanylist(this.searchVal)
      } else {
        this.getLaborcompanylist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getLaborcompanylist(this.searchVal)
      } else {
        this.getLaborcompanylist()
      }
    }
  },
  watch: {
    searchVal (val) {
      this.searchVal = val
    }
  },
  mounted () {
    this.getLaborcompanylist()
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
